import { hasCarlineFromExternalContent } from '../../helpers/form-helpers';
import { CarlineWithSalesgroups, SalesgroupWithCarline } from '../../types/vehicle-types';
import { externalContentManager } from '../external-content';
import { fetchCarlinesWithSalesgroups } from './fetch/data-fetch';
import {
	filterAvailableCarlinesForCurrentForm,
	filterCarlinesByMotorizacion,
	isCarlineAvailableForCurrentForm,
} from './helpers/carline-filters';

export const getSalesgroup = async (nameOrCode?: string | number): Promise<CarlineWithSalesgroups | null> => {
	if (!nameOrCode) return null;

	const response = await fetchCarlinesWithSalesgroups();

	if (response) {
		const matchingSalesgroup = response.find(
			(salesgroup) => salesgroup.name == nameOrCode || salesgroup.code == nameOrCode,
		);
		return matchingSalesgroup && isCarlineAvailableForCurrentForm(matchingSalesgroup) ? matchingSalesgroup : null;
	}
	return null;
};

// Obtiene salesgroups desde salesgroupCode[] y salesgroupName[]
export const getSalesgroups = async (): Promise<SalesgroupWithCarline[] | null> => {
	const carlines = await fetchCarlinesWithSalesgroups();
	if (!carlines) return null;

	const availableCarlines = filterAvailableCarlinesForCurrentForm(carlines);
	if (!availableCarlines) return null;

	const carlinesByMotorizacion = filterCarlinesByMotorizacion(availableCarlines);
	const carlinesToUse = carlinesByMotorizacion ? carlinesByMotorizacion : availableCarlines;

	const externalCarlines = externalContentManager.salesgroups;

	// Map para agrupar por nombre y conservar solo el salesgroup más reciente
	const salesgroupByName = new Map<string, SalesgroupWithCarline>();

	carlinesToUse.forEach((carline) => {
		carline.salesgroups?.forEach((salesgroup) => {
			if (
				externalCarlines &&
				!externalCarlines.includes(salesgroup.name) &&
				!externalCarlines.includes(String(salesgroup.code))
			) {
				return;
			}

			const salesgroupWithCarline: SalesgroupWithCarline = {
				...salesgroup,
				carline,
			};

			const existing = salesgroupByName.get(salesgroup.name);
			// Si no hay uno previo o el actual es más reciente, lo guardamos
			if (!existing || salesgroup.year > existing.year) {
				salesgroupByName.set(salesgroup.name, salesgroupWithCarline);
			}
		});
	});

	const result = Array.from(salesgroupByName.values());

	return result.length > 0 ? result : null;
};

// Obtiene salesgroups desde salesgroupCode[] y salesgroupName[] solo los definidos en externalContent.salesgroups.
export const getExternalContentSalesgroups = async (): Promise<SalesgroupWithCarline[] | null> => {
	// Si no tenemos salesgroups en externalContent, no devolvemos nada
	if (!externalContentManager.salesgroups) {
		return null;
	}

	// Es obligatorio definir un carline como fallback por si no se encuentra el salesgroup
	if (!hasCarlineFromExternalContent()) {
		return null;
	}

	return getSalesgroups();
};
